import { clearAuth, setAccessToken } from '@/lib/auth'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { client } from './client'

// Types
export interface LoginRequest {
  email: string
  password: string
}

export interface LoginResponse {
  access_token: string
  expires_in: number
}

// API functions
const login = (data: LoginRequest): Promise<LoginResponse> =>
  client.post('/auth/login', data, { skipAuth: true })

const logout = (): Promise<void> => client.post('/auth/logout', {})

const logoutAll = (): Promise<void> => client.post('/auth/logout-all', {})

// React Query hooks
export function useLogin() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: login,
    onSuccess: (data) => {
      setAccessToken(data.access_token)
      queryClient.invalidateQueries({ queryKey: ['users', 'me'] })
    },
  })
}

export function useLogout() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: logout,
    onSuccess: () => {
      clearAuth()
      queryClient.clear()
    },
  })
}

export function useLogoutAll() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: logoutAll,
    onSuccess: () => {
      clearAuth()
      queryClient.clear()
    },
  })
}
